const RecipeInstructionFields = {
  INSTRUCTION: 'instruction',
};

export default RecipeInstructionFields;
